import app from "firebase/app";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyDxkoMt0yyHbyVlBNh2R73nrJXRVaqED4I",
  authDomain: "aligatoritsolution.firebaseapp.com",
  databaseURL: "https://aligatoritsolution.firebaseio.com",
  projectId: "aligatoritsolution",
  storageBucket: "aligatoritsolution.appspot.com",
  messagingSenderId: "286487179919",
  appId: "1:286487179919:web:dcc1ae91771f63675bb6fa",
  measurementId: "G-CW9H92M81S",
};
class Firebase {
  constructor() {
    app.initializeApp(config);
  }
  addData(data) {
    const db = app.firestore();
    // data.push({ date: app.firestore.Timestamp.now });
    data.time = app.firestore.Timestamp.now();
    db.collection("client")
      .add(data)
      .catch((e) => {
        console.log(e);
      })
      .then((v) => {
        document.getElementById("message-label").style.display = "block";
        console.log(v.id);
        setTimeout(() => {
          document.getElementById("message-label").style.display = "none";
        }, 3000);
      });
  }

  async searchNewsletter(email) {
    const db = app.firestore().collection("newsletter-subscriber");
    const msgLabel = document.getElementById("subscribe-message");
    await db
      .where("email", "==", email)
      .get()
      .then((v) => {
        const isEmpty = v.empty;
        // console.log(isEmpty);
        if (isEmpty) {
          console.log("not exist");
          db.add({
            email: email,
            time: app.firestore.Timestamp.now(),
          })
            .catch((e) => {
              console.log(e);
            })
            .then((v) => {
              console.log(v.id);
              msgLabel.innerHTML = `Thanks for Subscribing!!
              <span role="img" aria-label="heart Emoji">
                💖
              </span>`;
              msgLabel.style.visibility = "visible";
              setInterval(() => {
                msgLabel.style.visibility = "hidden";
              }, 2000);
            });
        } else {
          console.log("already exist");
          msgLabel.innerHTML = "You already Subscribed!";
          msgLabel.style.visibility = "visible";
          setInterval(() => {
            msgLabel.style.visibility = "hidden";
          }, 2000);
        }
      })
      .catch((e) => console.log("Error:" + e));
  }

  addNewsletter(data) {
    this.searchNewsletter(data);
  }
}
export default Firebase;
